import { PaymentType } from "@/common/enum/payment-type";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import { PartnerOrderPaymentTableRow } from "./PartnerOrderPaymentTableRow1";

interface Props {
  orderDetail: OrderDetailDto;
}

const headers: TableHeader[] = [
  { title: "결제 수단", width: "w-[412px]" },
  { title: "결제 금액", width: "w-[412px] border-l border-semantic-divider" },
  { title: "결제 상태", width: "w-[412px] border-l border-semantic-divider" },
  {
    title: "국세청 세금계산서 번호",
    width: "w-[412px] border-l border-semantic-divider",
  },
];

export const PartnerOrderPaymentTable: React.FC<Props> = ({ orderDetail }) => {
  return (
    <div className="overflow-x-auto rounded-lg border border-semantic-divider">
      <Table>
        <Table.Head>
          {headers
            .filter(
              (header) =>
                !(
                  header.title === "국세청 세금계산서 번호" &&
                  orderDetail.payment.paymentMethod !== PaymentType.PALT
                ),
            )
            .map((header) => (
              <Table.HeadCell
                key={header.title}
                className={
                  header.width +
                  " h-[46px] p-0 border-b border-semantic-divider"
                }
              >
                <div className={header.align}>
                  <CustomCell className="my-[12px] mx-[16px]">
                    <Footnote12Description
                      className={"text-semantic-text-secondary"}
                    >
                      {header.title}
                    </Footnote12Description>
                  </CustomCell>
                </div>
              </Table.HeadCell>
            ))}
        </Table.Head>
        <Table.Body className="divide-y">
          <PartnerOrderPaymentTableRow orderDetail={orderDetail} />
        </Table.Body>
      </Table>
    </div>
  );
};
